import { api } from 'services/api'

export async function fetchDevices() {
  const { data } = await api.get('/devices')

  return data
}
